const _ = require('lodash');
const angular = require('angular');
const serverErrors = module.exports = {};

serverErrors.fillForm = function (form, responseErrors, parentObject) {
    parentObject.serverErrors = {};
    // This is for the way signup is structured only. If possible, use the forEach beneath.
    _.forEach(form, function (n, key) {
        // Check if there exists that key in the error object
        if (!_.isNull(responseErrors) && responseErrors[key]) { // throwing null is not an object in Safari
            // set a server error
            form[key].$setValidity('serverError', false);
        } else if (key[0] !== '$') {
            // Input fields do not start with a $
            // clear any server error
            form[key].$setValidity('serverError', true);
        }
    });

    // Set any remaining messages.
    _.forEach(responseErrors, function (n) {
        // Deal with the fact that some responses come back differently
        if (form[n.FieldName]) {
            form[n.FieldName].$setValidity('serverError', false);
        }
        // Set overall message
        parentObject.serverErrors[n.FieldName] = n.Message;
    });

};

serverErrors.clearForm = function (form, parentObject) {
    parentObject.serverErrors = {};

    _.forEach(form, function (n, key) {
        if (key[0] !== '$') {
            if (angular.isObject(form[key])) {
                form[key].$setValidity('serverError', true);
            }
        }
    });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/servererrorfiller/servererrorfiller.js
 **/